// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sp8s","tabsBox":"styles_tabsBox__35etD","createButton":"styles_createButton__38UHu"};